import angular from 'angular'

import invoicingRoutes from './invoicing.routes'
import invoicingRun from './invoicing.run'
import invoicingCtrl from './invoicing.controller'

const name = 'invoicingRouting'

angular.module(name, [])
  .run(invoicingRun)
  .config(invoicingRoutes)
  .controller('invoicingCtrl', invoicingCtrl)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/invoicing/invoicing.module.js